'use client'

export default function CookieBotToggle() {
  const showCookieBot = () => {
    if (typeof window !== 'undefined') {
      window.Cookiebot.show()
    }
  }

  return <button onClick={showCookieBot}>Cookie Preferences</button>
}
